import React from 'react'
import './triangleDown.css'

const TriangleDown =()=> {
  return (<div className="triangle-down"/>)
}

export default TriangleDown